import { z } from 'zod';
import type { BaseEntity } from './common';
import type { ProfitCenter } from './profitCenter';
import { IntegrationSystemEnum } from './integrationSystem';

/**
 * Interfaccia per ProfitCenterIntegration
 * Rappresenta un'integrazione di un centro di profitto con sistemi esterni
 * Corrisponde al modello backend ProfitCenterIntegration
 */
export interface ProfitCenterIntegration extends BaseEntity {
	/** ID del centro di profitto sorgente */
	sourceId: number;
	/** Sistema di integrazione */
	system: IntegrationSystemEnum;
	/** Valore dell'integrazione nel sistema esterno (max 50 caratteri) */
	value: string;
	/** Centro di profitto sorgente (navigation property, popolata con $expand=source) */
	source?: ProfitCenter;
}

/**
 * Schema Zod per la validazione runtime dei ProfitCenterIntegration
 */
export const ProfitCenterIntegrationSchema = z.object({
	id: z.number(),
	sourceId: z.number(),
	system: z.nativeEnum(IntegrationSystemEnum),
	value: z.string(),
	// Campi audit da BaseEntity
	createdAt: z.string(),
	modifiedAt: z.string().optional(),
	createdBy: z.string(),
	modifiedBy: z.string().optional(),
	// Navigation property opzionale (non validata in runtime)
	source: z.any().optional(),
});
